import application_settings from '../applicationSettings';
import Event from './Event';

class TrackOrderDetails extends Event {
    eventName = 'oms_trackOrderDetails';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get tracking order details
     * 
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        let multiCallKey = (data.multi_call_key) ? data.multi_call_key : 'check_order';
        
        if (clientId && data.checking_id) {
            data.endPoint = application_settings.endPoints.getOrderDetails;
            data.multi_call_key = multiCallKey;
            data.data = {
                client_id: clientId,
                checking_id: data.checking_id,
                order_currency: data.order_currency,
            };
            
            this.sendRequest(data, function(response) {
                if (response) {
                    let data = thisObj.formatResponseData(response);
                    thisObj.onSuccessEvent(data, {
                        'action' : action, 
                        'request_id' : requestId, 
                    });
                }
            });
        } else {
            //fire error event
            thisObj.onErrorEvent({ "message": "clientId & checking_id are required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }
}

export default TrackOrderDetails;